// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BecomeHost-container-jNCAD {
  margin: 0 auto;
  padding: 0 0 0px;
  max-width: var(--max-container-width);
  margin-top: 1px;
}`, "",{"version":3,"sources":["webpack://./src/routes/becomeHost/BecomeHost.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;AACjB","sourcesContent":[".container {\n  margin: 0 auto;\n  padding: 0 0 0px;\n  max-width: var(--max-container-width);\n  margin-top: 1px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BecomeHost-container-jNCAD`
};
module.exports = ___CSS_LOADER_EXPORT___;
